import React from 'react'
import { useState } from 'react';
import { Modal, Button as ButtonBootstrap } from "react-bootstrap";import Maximize from './Maximize';
import Minimize from './Minimize';

const ConfirmationDelete = (props) => {
    const [fullscreen, setFullscreen] = useState(false);

    const fullscreenHandler = () => {
      setFullscreen(!fullscreen);
    };

    return (
      <Modal
        show={props.show}
        onHide={props.hide}
        className={!fullscreen && "confirmation-modal"}
        size="xss"
        fullscreen={fullscreen}
      >
        <Modal.Header closeButton style={{ position: "relative" }}>
          <Modal.Title style={{fontSize:"17px"}}>{props.title}</Modal.Title>
          <button
            style={{
              position: "absolute",
              right: "40px",
              top:"3px",
              padding: "0 0 1px 0",
              background: "none",
              border: "none",
            }}
            type="button"
            class="btn btn-primary"
            onClick={fullscreenHandler}
          >
            {fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body>
          <h5 style={{fontWeight:"400"}}>
            {props.msg}
          </h5>
        </Modal.Body>

        <Modal.Footer>
          <ButtonBootstrap
            variant="primary"
            className="btnPrimary"
            onClick={props.confirm}
          >
            {props.firstButton ? props.firstButton : "Yes"}
          </ButtonBootstrap>
          <ButtonBootstrap
            variant="secondary"
            className="btnSecondary"
            onClick={props.hide}
          >
            {props.secondButton ? props.secondButton : "No"}
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal>
    );
}

export default ConfirmationDelete